// ==============================================
// Environment Detection (Edge Runtime Compatible)
// ==============================================
// This file provides environment detection that works in Next.js Edge Runtime
// Used by middleware.ts which runs in Edge Runtime context

export const IS_PRODUCTION = process.env.VERCEL_ENV === "production";
export const IS_PREVIEW = process.env.VERCEL_ENV === "preview";
export const IS_DEVELOPMENT =
  !process.env.VERCEL_ENV ||
  process.env.VERCEL_ENV === "" ||
  process.env.VERCEL_ENV === "development" ||
  // NB: when an env is set to null, it becomes a string "null"
  process.env.VERCEL_ENV === "null";

// Validation: exactly one environment flag must be true
const environmentFlags = [IS_PRODUCTION, IS_PREVIEW, IS_DEVELOPMENT];
const trueCount = environmentFlags.filter(Boolean).length;
if (trueCount !== 1) {
  throw new Error(
    `Invalid environment configuration: exactly one of IS_PRODUCTION, IS_PREVIEW, IS_DEVELOPMENT must be true, but ${trueCount} are true. VERCEL_ENV="${process.env.VERCEL_ENV}"`,
  );
}

// temporary debugging flag before migrating to consola
const DEBUG_ALL = process.env.DEBUG_ALL === "true";
export const DEBUG_AUTH = DEBUG_ALL || process.env.DEBUG_AUTH === "true";
export const DEBUG_MIDDLEWARE =
  DEBUG_ALL || process.env.DEBUG_MIDDLEWARE === "true";
export const DEBUG_MAPS_API =
  DEBUG_ALL || process.env.DEBUG_MAPS_API === "true";
export const DEBUG_EVENTS_CLIENT =
  DEBUG_ALL || process.env.DEBUG_EVENTS_CLIENT === "true";
